export default "__VITE_ASSET__C128dxSC__"